// src/index.js

import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import { BrowserRouter as Router } from "react-router-dom";
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";
import "./i18n"; // import config

import "./index.css";
import "./common.css";

//Initialize Facebook SDK
//import { accountService } from '_services';

// Facebook App ID should come from an environment variable so it's not hard-coded.
// For local development set `REACT_APP_FACEBOOK_APP_ID` in your `.env` file.
const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID || "";

if (!facebookAppId) {
    console.warn('REACT_APP_FACEBOOK_APP_ID is not set. Facebook SDK may not initialize correctly.');
}

const initFacebookSdk = () => {
    return new Promise(resolve => {
        // wait for facebook sdk to initialize before starting the react app
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v21.0'
            });

            // auto authenticate with the api if already logged in with facebook
            // window.FB.getLoginStatus(({ authResponse }) => {
            //     if (authResponse) {
            //         accountService.apiAuthenticate(authResponse.accessToken).then(resolve);
            //     } else {
            //         resolve();
            //     }
            // });
            resolve();
        };
   
        // load facebook sdk script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        //Below code changes facebook texts to Spanish
        // (function(d){
        //     var js, id = 'facebook-jssdk'; if (d.getElementById(id)) {return;}
        //     js = d.createElement('script'); js.id = id; js.async = true;
        //     js.src = "https://connect.facebook.net/es_LA/all.js";
        //     d.getElementsByTagName('head')[0].appendChild(js);
        //   }(document));
    });
}


// wait for facebook sdk before startup
initFacebookSdk().then(startApp);
//Deployment: Use "npm run-script build" for production build
function startApp() {
    ReactDOM.render(
        <Router>
          <Auth0ProviderWithHistory>
            <App />
          </Auth0ProviderWithHistory>
        </Router>,
        document.getElementById("root")
    );
}